document.addEventListener('DOMContentLoaded', function() {
      // सभी बटन सिलेक्ट करें जिनका ID "add-to-cart-button" है
      const addToCartButtons = document.querySelectorAll('#add-to-cart-button');

      addToCartButtons.forEach(button => {
        button.addEventListener('click', function(event) {
          event.preventDefault(); // बटन का डिफ़ॉल्ट एक्शन रोकें

          // बटन से वैरिएंट ID प्राप्त करें
          const variantId = this.getAttribute('data-variant-id');

          // कार्ट में प्रोडक्ट जोड़ने के लिए डेटा तैयार करें
          let formData = {
            'items': [{
              'id': variantId,
              'quantity': 1
            }]
          };

          // Shopify कार्ट API को POST रिक्वेस्ट भेजें
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(data => {
            console.log('Product added to cart:', data);
            // उपयोगकर्ता को कार्ट पेज पर रीडायरेक्ट करें
            window.location.href = '/cart';
          })
          .catch(error => console.error('Error adding product to cart:', error));
        });
      });
    });



